import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import OrthopedicCare from './OrthopedicCare'
import About from './About'
import Clinic from './Clinic'
import "./Home.css";
import Shanmedical from './Shanmedical'
import ScrollToTop from "react-scroll-to-top"
import drrajkishoresarkar_operation from "../images/Dr. Sarkar’s Orthopedic Surgery.png"
import GoogleMap from './GoogleMap'
function Home() {
  return (
    <div>
      <Navbar/>
      <br/>
      <br/>
       <ScrollToTop smooth top="100" color="Gray" />
       
      <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href="tel: 7699370023" className="orthopedicskatwaBardhaman" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      </svg> Book Appointment </a></div>
          <div className="album py-1">
                <div className="container">
                  <h5>Dr. Rajkishore Sarkar</h5>
                  </div>
                </div>
      <Slider/>
       <div className="bestorthopedicskatwa">
        <div className="album py-0">
          <div className="container">
            <marquee><h5 className='mt-3' style={{ color: "white" }}> Welcome to Shan Medical – Circus Maidan, Hospital Para, Dutta Road Near by Dr. B C ROY POLICLINIC Katwa, Dist-Bardhaman, Pin: 713130, West Bengal | India</h5></marquee>
          </div>
        </div>
      </div>
      <br/>
      <OrthopedicCare/>
      <br/>
       
<About/>
<br/>
<div className='borderradius'>
        <div className="album py-1">

                    <div className="container">
           <img src={drrajkishoresarkar_operation} className="img-fluid" alt="drrajkishoresarkar" />

                      </div>
                      </div>
                    </div>
                    <br/>
<div className='clinicback'>
  <br/>
  <Clinic/>
  <br/>
</div>

<br/>
<Shanmedical/>
<br/>
<GoogleMap/>
<br/>
{/* <br/>

<div className="album py-0">
                <div className="container">
                    <div className="row ">
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src="..." className="card-img-top" alt="..." />
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <br/>
    </div>
  )
}

export default Home